import type { FormHeaderProps } from './form-header.interface';
import type { FC } from 'react';

import React from 'react';

import { Container } from '../container/container';

export const FormHeader: FC<FormHeaderProps> = (props: FormHeaderProps) => {
  const { renderSave, renderDelete, renderReport, renderDocxReport } = props;
  return (
    <Container>
      <div className={'form-controls'}>
        {renderSave}
        {renderDelete}
        {renderDocxReport}
        {renderReport}
      </div>
    </Container>
  );
};
